import React from 'react'
import SignUpComp from '../components/SignUp/SignUpComp'

const SignUp = () => {
  return (
    <>
        <SignUpComp/> 
  
    </>
  )
}

export default SignUp